<template>
    <div class="sld_login">
        <div class="sld_login_header">
            <div class="content">
                <router-link tag="a" class="l_logo" :to="`/index`">
                    <img src="../../../assets/common_top_logo.png" class="img" />
                </router-link>
                <div class="r_register_wrap">
                    {{L['我已知悉？']}}
                    <a class="go_register_btn" @click="goRegister">
                        {{L['去注册']}}
                    </a>
                </div>
            </div>
        </div>
        <div class="agreement_container">
            <h2 class="agreement_title">{{agreeContent.title}}</h2>
            <pre v-html="agreeContent.content"></pre>
        </div>
    </div>
</template>

<script>
    import { useRouter } from 'vue-router'
    import { getCurrentInstance, reactive, onMounted } from 'vue';

    export default {
        name: "Agreement",
        setup() {
            const router = useRouter()
            const { proxy } = getCurrentInstance();
            const L = proxy.$getCurLanguage();
            const agreeContent = reactive({
                content: '',
                title: ''
            })
            const agreementCode = reactive({
                agreementCode: 'register_agreement'
            })
            const getInitData = () => {
                proxy.$get('/v3/system/front/agreement/detail', agreementCode).then(res => {
                    if (res.state == 200) {
                        agreeContent.content = res.data.content
                        agreeContent.title = res.data.title
                    }
                })
            }

            const goRegister = () => {
                router.push({
                    path: '/register'
                })
            }
            onMounted(() => {
                getInitData()
            })

            return { L, agreeContent, goRegister }
        },
    };
</script>
<style lang="scss" scoped>
    @import '../../../style/agreement.scss';
</style>
